module.exports = __webpack_public_path__ + "img/apple.d8f6c9ee.svg";